import * as React from 'react';
import {  useState } from 'react';
import SkillFileComponent from './SkillFileComponent';
import { Control, Controller, useFieldArray, UseFormGetValues, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { SkillForm } from './AgentSkillsComponent';
import { FileProps } from '../../../../shared/DragAndDrop';
import { useTranslate } from 'sbx-crm-menu-ui';
import { Button } from '../../../../ui/button';
import SkillKeyValueConfigComponent from './SkillKeyValueConfigComponent';
import { EnumSkillRetrieverFields } from 'src/types/Common';

type Props = {
    name: string // skill form name (config, action_retriever)
    group?:string,
    setFiles: (files: File[]) => void
    files: File[]
    filesComponent: FileProps[]
    setFilesComponent: (files: FileProps[]) => void
    deleteFile: (file: FileProps) => void
    control: Control<SkillForm>
    watch: UseFormWatch<SkillForm>
    getValues: UseFormGetValues<SkillForm>;
    setValues: UseFormSetValue<SkillForm>;
    register: UseFormRegister<SkillForm>;
    unregisterUnusedRetrieverFields?: (field: EnumSkillRetrieverFields) => void
    dataScience?: boolean;
};
const classNameLabel = 'form-input-label';
const SkillCustomRetrieverFields = ({
                                        name,
                                        group,
                                        deleteFile,
                                        files,
                                        filesComponent,
                                        setFilesComponent,
                                        setFiles,
                                        control, watch, getValues,
                                        setValues,
                                        register,
                                        unregisterUnusedRetrieverFields,
                                        dataScience,
                                    }: Props) => {
    const [website, setWebsite] = useState('');
    const { t: agent } = useTranslate('agent');
    const { t: common } = useTranslate('common');
    
    const columnsToReturn = useFieldArray({
        name: `new_skill.${name}.columns_to_return` as any,
        control,
    });


    const columnsDescription = useFieldArray({
        name: `new_skill.${name}.columns_description` as any,
        control,
    });

    return (
        <>
            <SkillFileComponent
                setFilesComponent={setFilesComponent}
                setFiles={setFiles}
                files={files}
                filesComponent={filesComponent}
                deleteFile={(file) => deleteFile(file)} 
                typeExcelOnly={group === EnumSkillRetrieverFields.EXCEL}
                onchange={unregisterUnusedRetrieverFields} />

            {group === EnumSkillRetrieverFields.EXCEL ?
            
            <div
                className={`grid grid-cols-2 gap-3 mb-3`}>
                    <SkillKeyValueConfigComponent label={agent('columns_to_return')}
                                                placeholderKey={common('name')}
                                                placeholderValue={common('description')}
                                                append={() => {
                                                    if (dataScience) {
                                                        columnsDescription.append({
                                                            name: '',
                                                            value: '',
                                                        });
                                                    } else {
                                                        columnsToReturn.append({
                                                            name: '',
                                                            value: '',
                                                        });
                                                    }
                                                }}
                                                config={name}
                                                name={dataScience ? `columns_description` : `columns_to_return`}
                                                buttonLabel={`${common('add')} ${agent('columns_to_return')}`}
                                                formArray={dataScience ? columnsDescription : columnsToReturn}
                                                register={register} 
                                                onchange={() => unregisterUnusedRetrieverFields && unregisterUnusedRetrieverFields(EnumSkillRetrieverFields.EXCEL)} />
            </div>
            
            :
            <>
            <Controller render={({ field }) => {
                return <div className="grid gap-1 items-center mb-5">
                    <label htmlFor="" className="form-input-label">{agent('websites')}</label>
                    <div className="grid grid-cols-[1fr_auto] gap-2">
                        <input
                            type="text"
                            autoComplete={'off'}
                            value={website}
                            className="py-2 px-4  rounded border border-gray-400 outline-none resize-none"
                            placeholder="https://example.com"
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    event.preventDefault();
                                    setWebsite('');
                                    field.onChange([...(field.value ?? []), website]);
                                }
                            }}
                            onChange={(event) => {
                                setWebsite(event.target.value);
                            }}
                        />
                        <div className="">
                            <Button className="primary-gradient-button" onClick={() => {
                                field.onChange([...((field.value ?? [])), website]);
                                setWebsite('');
                            }}>
                                + {common('add')}
                            </Button>
                        </div>
                    </div>
                </div>;
            }} name={`new_skill.${name}.url` as any} control={control} />

            <div className="grid gap-1 items-center mb-5">
                <h2 className={classNameLabel}>{agent('websites_includes')}</h2>
                <div className="flex flex-wrap gap-3 my-2">
                    {
                        watch(`new_skill.${name}.url` as keyof SkillForm) ? watch(`new_skill.${name}.url` as any)?.map((website: string, index: number) => (
                            <div key={index} className="bg-white shadow p-2 border border-gray-400 rounded flex gap-4">
                                <p className="text-sm">{website}</p>
                                <span
                                    className="cursor-pointer text-red-400 w-5 h-5 flex justify-center items-center"
                                    onClick={() => {
                                        const filterUrl = getValues('new_skill.config.url')?.filter((_, i) => i !== index);
                                        if(filterUrl) {
                                            if(filterUrl.length > 0) {
                                                setValues('new_skill.config.url', filterUrl);
                                            } else {
                                                setValues('new_skill.config.url', null);
                                            }
                                        }
                                    }}
                                >
                              <FontAwesomeIcon icon={faTimesCircle as any} />
                          </span>
                            </div>
                        )) : null
                    }
                    {
                        (!watch(`new_skill.${name}.url` as keyof SkillForm) || watch(`new_skill.${name}.url` as any)?.length === 0) && (
                            <p className="text-gray-300">{
                                agent('no_websites')
                            }</p>
                        )
                    }
                </div>
            </div>
            </>
            }
        </>
    );

};

export default SkillCustomRetrieverFields;